<vue-panel [title]="'label.personalInformation' | translate: 'PortalBase' | async">
    <vue-read-only-form [items]="items" i18nBundle="PortalBase"></vue-read-only-form>
</vue-panel>
